// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"383e212a","429":"73ab1972","494":"50670470"}[chunkId] + ".chunk.css";
};